import React from 'react';
import styled from 'styled-components';
import Img from './Img';
import {breakPoint} from '../styles/var';
import {NoStyleButton} from './Button';

import img_btn_1 from '../assets/img/pc03-5.png';


const CardStyles = styled.div`
  width: 100%;

  .avatar {
    max-width: 24rem;
    margin-right: auto;
    margin-left: auto;
  }

  .content {
    list-style: none;
    padding-left: 0;

    span {
      margin-left: .8rem;
    }
  }

  .name {
    text-align: center;
  }

  .wrap {
    display: flex;
    justify-content: center;
    gap: 1rem;
  }
  
  .count {
    color: #FF0000;
    margin: 0;
  }

  @media (max-width: ${breakPoint.smMin}) {
    .content {
      span {
        margin-left: .4rem;
      }
    }
  }
`


const Card = ({info = {}, vote = 0, handleShowModal, ...props}) => {
    const {name, picUrl} = info;
    return (
        <CardStyles {...props}>
            <Img src={picUrl} wrapProps={{className: "avatar"}}/>
            <h4 className={"name"}>{name}</h4>
            <div className="wrap">
                <p className={"count"}>{`${vote}票`}</p>
                <NoStyleButton as="button" onClick={handleShowModal}>
                    <Img src={img_btn_1}/>
                </NoStyleButton>
            </div>
        </CardStyles>
    )
}

export default Card;
